export * from './src/avatar.component';
